module.exports = global["LOCALE"] = require("-!/app/node_modules/tojson-loader/index.js!/app/node_modules/regexp-replace-loader/index.js?{match:{pattern:\"\\\\$LOCALE\",flags:\"g\"},replaceWith:\"nl\"}!/app/node_modules/babel-loader/lib/index.js!/app/build/export-locale.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?LOCALE!./~/tojson-loader!./~/regexp-replace-loader?{match:{pattern:"//$LOCALE",flags:"g"},replaceWith:"nl"}!./build/export-locale.js
// module id = 0
// module chunks = 17